module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar title \t\t= model.title || ''\nvar titleRight \t= model.titleRight || ''\nvar message \t= model.message || ''\nif(model.titleKey) \t\ttitle \t\t= storage.__(model.titleKey);\nif(model.titleRightKey) titleRight \t= storage.__(model.titleRightKey);\nif(model.messageKey) \tmessage \t= storage.__(model.messageKey);\n%>\n<div>\n<%\nif(title || titleRight){\n%>\n<div class=\"head\">\n<div><%= title %></div>\n<div><%= titleRight %></div>\n</div>\n<%\n}\n%>\n<div class=\"content\">\n<p><%- message %></p>\n</div>\n</div>"
  , __filename = "..\\frontend-controller\\baseComponents\\tooltip\\content.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var title 		= model.title || ''
var titleRight 	= model.titleRight || ''
var message 	= model.message || ''
if(model.titleKey) 		title 		= storage.__(model.titleKey);
if(model.titleRightKey) titleRight 	= storage.__(model.titleRightKey);
if(model.messageKey) 	message 	= storage.__(model.messageKey);

    ; __line = 8
    ; __append("\n<div>\n")
    ; __line = 10
    ; 
if(title || titleRight){

    ; __line = 12
    ; __append("\n<div class=\"head\">\n<div>")
    ; __line = 14
    ; __append(escapeFn( title ))
    ; __append("</div>\n<div>")
    ; __line = 15
    ; __append(escapeFn( titleRight ))
    ; __append("</div>\n</div>\n")
    ; __line = 17
    ; 
}

    ; __line = 19
    ; __append("\n<div class=\"content\">\n<p>")
    ; __line = 21
    ; __append( message )
    ; __append("</p>\n</div>\n</div>")
    ; __line = 23
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\tooltip\content.ejs

}